// extracted by mini-css-extract-plugin
module.exports = {"container":"apartment-module--container--fZ-LV","titleContainer":"apartment-module--titleContainer--3k1X3","title":"apartment-module--title--nDX_t"};